import { ReactNode } from 'react';
import MainContainer from 'src/components/common/MainContainer';
import Footer from 'src/components/Footer';
import PoweredByBadge from 'src/features/Public/PoweredByBadge';

const IframeLayout = ({ children }: { children: ReactNode }) => {
  return (
    <MainContainer sx={{ position: 'relative' }}>
      {children}
      <PoweredByBadge />
      <Footer />
    </MainContainer>
  );
};

export default IframeLayout;
